/**
 * @name ChangePassword
 * @description Componente para cambiar la contraseña en configuración de perfil
 * @author Ricardo Guerra
 */

import React, { PureComponent } from 'react';

import { PasswordForm } from '@components';
import { ResponseHandlerService, UserService } from '@services';

class ChangePassword extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  configPassword = (values, setSubmitting, resetForm, resetPasswordCheck) => {
    UserService.postPass({
      ContraseñaAnterior: values.oldPassword,
      ContraseñaNueva: values.newPassword,
      ConfirmarContraseña: values.confirmPassword
    }).then((response) => {
      setSubmitting(false);
      resetForm();
      resetPasswordCheck();
      ResponseHandlerService.success(response);
    }).catch((error) => {
      setSubmitting(false);
      ResponseHandlerService.error(error);
    });
  }

  render() {
    return (
      <PasswordForm
        changePassword={true}
        retrievePassword={false}
        onConfigPassword={this.configPassword}
      />
    );
  }
}

export default ChangePassword;
